import { Box, Typography } from "@mui/material";

type IStatusTag = {
    border:string,
    bgColor:string,
    txtColor:string,
    label:string,
    id:string,
    icon: JSX.Element
}

export const StatusTag =({
  border,
  bgColor,
  txtColor,
  id,
  icon,
  label
}:IStatusTag)=>{

  return(
    <Box
      id={ id }
      tabIndex={ -1 }
      sx={ {
        opacity:0,
        position:"absolute",
        alignItems:"center",
        zIndex: "1",
        right:"1rem",
        top:"2rem",
        backgroundColor: bgColor,
        border: border,
        borderRadius: "0.25rem",
        height: "1.5625rem",
        padding: "0.10938rem 0.4375rem",
        gap: "0.25rem",
        display:"flex",
        color: txtColor
      } }
    >
      { icon }
      <Typography tabIndex={ -1 } id={ id } sx={ { fontSize: "0.75rem", fontWeight: "600" } }
      >
        {  label }
      </Typography>
    </Box>
  );
};
